import { render, staticRenderFns } from "./audioStatement.vue?vue&type=template&id=673324ba&scoped=true&"
import script from "./audioStatement.vue?vue&type=script&lang=js&"
export * from "./audioStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673324ba",
  null
  
)

export default component.exports